module.exports = {"TXTWCL_Copied":{"id":"TXTWCL_Copied","defaultMessage":"コピー済み"}}